let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4x4hO")).then(() => parcelRequire('75fKF'));